import {LOAD_MESSAGE_DATA, DELETE_A_MESSAGE, SAVE_A_MESSAGE, UPDATE_A_MESSAGE,CLEAR_A_MESSAGE_ERROR_MESSAGE} from './actions';


const initialState = {
  messagesArray:[],
    deleteMessageResp:{},
    errorCMsg:{},
    saveMessageResp:{},
    updateMessageResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_MESSAGE_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_MESSAGE_DATA:
          return Object.assign({}, state, {
              messagesArray: action.messagesData
          });
          case DELETE_A_MESSAGE:
          return Object.assign({}, state, {
              deleteMessageResp: action.deleteMessageResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_MESSAGE:
          return Object.assign({}, state, {
              saveMessageResp: action.saveMessageResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_MESSAGE:
          return Object.assign({}, state, {
              updateMessageResp: action.saveMessageResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
